













import Vue from "vue";

interface Data {
  target: HTMLElement | undefined;
}

interface Methods {
  setTarget(targetElement: any): void;
  initScrollbar(): void;
}

interface Props {
  direction: string;
}

export default Vue.extend<Data, Methods, {}, Props>({
  components: {
    //...
  },

  props: {
    direction: {type: String, required: true},
  },

  mounted() {
    this.$nextTick(() => {
      this.initScrollbar();
    });
  },

  data() {
    return {
      target: undefined,
    };
  },

  computed: {
    //...
  },

  methods: {
    setTarget(targetElement) {
      this.target = (targetElement as HTMLElement);

      this.$nextTick(() => {
        this.initScrollbar();
      });
    },
    initScrollbar() {
      this.$nextTick(() => {
        if (!["x", "y"].includes(this.direction)) { return; }

        const scrollTarget = this.target as HTMLElement;
        const scrollbar = this.$refs.customScrollbar as HTMLElement;
        const thumb = this.$refs.customScrollbarThumb as HTMLElement;
    
        //Horizontális scrollbar
        if (this.direction == "x") {
          const updateThumb = () => {
            const containerWidth = scrollbar.clientWidth;
            const contentWidth = scrollTarget.scrollWidth;
            const visibleWidth = scrollTarget.clientWidth;

            const ratio = visibleWidth / contentWidth;
            const thumbWidth = Math.max(containerWidth * ratio, 30);
            thumb.style.width = `${thumbWidth}px`;

            const left = (scrollTarget.scrollLeft / (contentWidth - visibleWidth)) * (containerWidth - thumbWidth);
            thumb.style.transform = `translateX(${left}px)`;
          };

          scrollTarget.addEventListener('scroll', updateThumb);
          window.addEventListener('resize', updateThumb);
          this.$nextTick(updateThumb);

          let isDragging = false;
          let startX = 0;
          let startScrollLeft = 0;

          const onMouseMove = (e: MouseEvent) => {
            if (!isDragging) return;

            const dx = e.pageX - startX;
            const scrollRatio = scrollTarget.scrollWidth / scrollbar.clientWidth;          
            scrollTarget.scrollLeft = startScrollLeft + dx * scrollRatio;
          };

          const onMouseUp = () => {
            isDragging = false;
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            document.body.style.userSelect = '';
          };

          thumb.addEventListener('mousedown', (e) => {
            isDragging = true;
            startX = e.pageX;
            startScrollLeft = scrollTarget.scrollLeft;
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
            document.body.style.userSelect = 'none';
          });
        }

        //TODO: Vertikális scrollbar
        // if (this.direction == "y") {
        //   const updateThumb = () => {
        //     const containerHeight = scrollbar.clientHeight;
        //     const contentHeight = scrollTarget.scrollHeight;
        //     const visibleHeight = scrollTarget.clientHeight;

        //     const ratio = visibleHeight / contentHeight;
        //     const thumbHeight = Math.max(containerHeight * ratio, 30);
        //     thumb.style.height = `${thumbHeight}px`;

        //     const top = (scrollTarget.scrollTop / (contentHeight - visibleHeight)) * (containerHeight - thumbHeight);
        //     thumb.style.transform = `translateY(${top}px)`;
        //   };

        //   scrollTarget.addEventListener('scroll', updateThumb);
        //   window.addEventListener('resize', updateThumb);
        //   this.$nextTick(updateThumb);

        //   let isDragging = false;
        //   let startY = 0;
        //   let startScrollTop = 0;

        //   const onMouseMove = (e: MouseEvent) => {
        //     if (!isDragging) return;

        //     const dy = e.pageY - startY;
        //     const scrollRatio = scrollTarget.scrollHeight / scrollbar.clientHeight;
        //     scrollTarget.scrollTop = startScrollTop + dy * scrollRatio;
        //   };

        //   const onMouseUp = () => {
        //     isDragging = false;
        //     document.removeEventListener('mousemove', onMouseMove);
        //     document.removeEventListener('mouseup', onMouseUp);
        //     document.body.style.userSelect = '';
        //   };

        //   thumb.addEventListener('mousedown', (e) => {
        //     isDragging = true;
        //     startY = e.pageY;
        //     startScrollTop = scrollTarget.scrollTop;
        //     document.addEventListener('mousemove', onMouseMove);
        //     document.addEventListener('mouseup', onMouseUp);
        //     document.body.style.userSelect = 'none';
        //   });
        // }
      });
    },
  },
});
